// extracted by mini-css-extract-plugin
export default {"transactionTable":"UserProfile_transactionTable__-yGMp"};